import { render, staticRenderFns } from "./ParcoursRead.vue?vue&type=template&id=1d7546ad"
import script from "./ParcoursRead.vue?vue&type=script&lang=js"
export * from "./ParcoursRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports